import { render, staticRenderFns } from "./_IbxItemCard.vue?vue&type=template&id=3ca891d8"
import script from "./_IbxItemCard.vue?vue&type=script&lang=js"
export * from "./_IbxItemCard.vue?vue&type=script&lang=js"
import style0 from "./_IbxItemCard.vue?vue&type=style&index=0&id=3ca891d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports